import './applied_reply_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostReplyFilterView extends Monitoring.Views.SocialContents.Filters.AppliedReplyFilterView

  getQuery: (action) ->
    "post_#{action}_#{@source}_replies"
